function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "16",
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 14.375h6M8.5 11.375v3",
  stroke: "#12002D",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 2.299c0-.032.012-.092.094-.163A.622.622 0 012.5 2h14.48c-.164-1.228-1.33-2-2.48-2h-12C1.26 0 0 .899 0 2.299V9.7C0 11.101 1.26 12 2.5 12h12c1.15 0 2.316-.772 2.48-2H2.5a.622.622 0 01-.406-.136C2.012 9.794 2 9.733 2 9.7V2.3z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 6h6M16 4l2 2-2 2",
  stroke: "#12002D",
  strokeWidth: "2",
  strokeLinecap: "round"
})));